import React, { Component } from 'react';
import { WatchlistNewsDomains } from '../../../domain/watchlist/WatchlistNewsDomains';
import moment from 'moment/moment';

class WatchlistNewsPanelComponent extends Component<Props> {
  public render() {
    const { newsResponse } = this.props;

    return (
      <div className='h-full w-full flex flex-col gap-y-4'>
        {newsResponse?.news.map((data, index) => {
          return (
            <div
              className='w-full flex gap-x-2 border rounded-[8px] h-full p-4 hover:shadow-lg cursor-pointer'
              key={index}
              onClick={() => window.open(data.url, '_blank')}
            >
              <div className={'w-4/5 flex flex-col gap-y-2'}>
                <div className={'flex items-center gap-x-2'}>
                  {data.providerThumbnailUrl == undefined ? (
                    <img src={'/icons/newspaper.svg'} className={'w-[16px] h-[16px]'} alt='newspaper' />
                  ) : (
                    <img src={data.providerThumbnailUrl} alt='image' className={'w-[16px] h-[16px] flex justify-center items-center rounded bg-[#EFF2FE]'} />
                  )}
                  <span className={'text-[#607080] text-[12px]'}>{data.provider}</span>
                  <span className={'text-f-black-3 text-[12px] ml-4'}>{moment(data.datePublished).format('LLL')}</span>
                </div>
                <div className={'flex flex-col gap-y-2'}>
                  <span className={'text-f-black-2 text-[18px] font-medium hover:text-[#458EF7] hover:underline cursor-pointer'}>{data.title}</span>
                  <span className={'text-f-black-3 text-[13px] text-wrap overflow-x-scroll'}>{data.description.substring(0, 150)}...</span>
                </div>
              </div>
              <div className={'h-[110px] w-1/5'}>
                {data.imageUrl == undefined ? (
                  <div className={'flex items-center justify-center h-full w-full bg-[#F9FAFB] rounded-[8px] border'}>
                    <img src={'/icons/newspaper.svg'} className={'w-[24px] h-[24px]'} alt='newspaper' />
                  </div>
                ) : (
                  <img src={data.imageUrl} className={'h-full w-full rounded-[8px] border object-cover'} />
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

interface Props {
  newsResponse: WatchlistNewsDomains | undefined;
}

export default WatchlistNewsPanelComponent;
